export default __webpack_public_path__ + "fonts/7f65.woff2";